// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Jo-z","badgeLink":"Ko-z","category":"Lo-z"};